<template>
  <img
      :src="imageSrc"
      v-bind="$attrs"
      :draggable="draggable"
  />
</template>

<script>
import noimage from '../../assets/img/no-image.jpg';

export default {
  name: 'ImageComponent',
  props: {
    path: {
      type: [Object, String],
    },
    draggable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    imageSrc() {
      if (!this.path) return noimage;

      if (typeof this.path === 'string') {
        if (this.path?.startsWith?.('data:image')) return this.path;

        return this.getImagePath(this.path);
      }
      if (typeof this.path === 'object') {
        const quality = Math.max(0, ...Object.keys(this.path).map(Number).filter(Number.isInteger));
        return this.getImagePath(this.path[quality]);
      }
      return noimage;
    },
  },
};
</script>

